import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quotation-notice-board',
  templateUrl: './quotation-notice-board.component.html',
  styleUrls: ['./quotation-notice-board.component.css'],
})
export class QuotationNoticeBoardComponent implements OnInit {
constructor() { }

  ngOnInit(): void {
  }

  
}
